import { useMemo } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { UserRole } from "@/types/auth";

// Papéis do usuário logado (vêm de /users/me, já carregado pelo AuthContext).
export const useUserRoles = () => {
  const { user } = useAuth();

  return useMemo(() => {
    const roles = (user?.roles ?? []) as UserRole[];
    const hasAnyRole = (allowed: UserRole[]) => allowed.some((role) => roles.includes(role));

    return {
      roles,
      hasAnyRole,
      isAccountAdmin: roles.includes("account-admin"),
      isFinanceManager: roles.includes("finance-manager"),
      isAnalyst: roles.includes("analyst"),
      isReader: roles.includes("reader"),
      // Contratar planos/produtos e ver dados de cobrança.
      canManageBilling: hasAnyRole(["account-admin", "finance-manager"]),
    };
  }, [user?.roles]);
};
